//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "QfColorPicker",
    props: {
        value: { type: String, default: "" },
        disable: { type: Boolean, default: false }
    },
    data() {
        return {
            showPicker: false,
            localColor: null,
            pickerColor: null
        };
    },
    computed: {
        viewStyle() {
            return { "background-color": this.localColor };
        }
    },
    watch: {
        value: {
            handler(val) {
                this.localColor = val;
            },
            immediate: true
        }
    },
    methods: {
        show() {
            if (!this.disable) {
                this.pickerColor = this.localColor;
                this.showPicker = true;
            }
        },
        cancel() {
            this.showPicker = false;
        },
        remove() {
            this.pickerColor = null;
            this.set();
        },
        set() {
            this.$emit("input", this.pickerColor);
            this.cancel();
        }
    }
};
